export default __webpack_public_path__ + "static/media/jægerforbund.59d44159.png";